// extracted by mini-css-extract-plugin
module.exports = {"IframeFak":"IframeFak_IframeFak__NX0lE"};